// extracted by mini-css-extract-plugin
export var actions = "_4q-0";
export var actionsContainer = "_4q-6";
export var border = "_4q-1";
export var childFullHeight = "_4q-d";
export var collapse = "_4q-2";
export var content = "_4q-8";
export var contentChild = "_4q-c";
export var fullscreen = "_4q-a";
export var headerContainer = "_4q-3";
export var headerRow = "_4q-5";
export var hidePadding = "_4q-9";
export var noScrollX = "_4q-e";
export var noScrollY = "_4q-f";
export var optOutTopPadding = "_4q-b";
export var pagePadding = "_4q-7";
export var profile = "_4q-g";
export var profileContainer = "_4q-h";
export var profileImage = "_4q-i";
export var profileMain = "_4q-j";
export var profileSubtitle = "_4q-l";
export var profileTitle = "_4q-k";
export var tabsWrapper = "_4q-4";
export var title = "_4q-m";